module.exports = __webpack_public_path__ + "img/ic_tripadvisor-4.5.ae32d2b6.svg";